import React from 'react';

const UserAgreement: React.FC = () => {
    return (
        <article className='aboutus'>
            <h1>用戶協議
            </h1>
            <p>本協議是您與龍門比分所有者易迪軟體有限公司（以下簡稱為"本公司"或“龍門比分”）之間就使用龍門比分旗下網站或應用程序等相關事宜所訂立的契約，請您在使用龍門比分相關服務之前認真閱讀本協議全部內容。
            </p>
            <ul >
                <li>1 本站用戶協議的生效與變更
                    <ul >
                        <li>1.1 本協議內容包括協議正文及各類相關規則。所有規則為本協議不可分割的組成部分，與協議正文具有同等法律效力。除另行明確聲明外，任何龍門比分及其關聯公司提供的服務（以下簡稱為"龍門比分服務”）均受本協議約束。</li>
                        <li>1.2 只要您使用龍門比分服務，則本協議即對您產生約束，屆時您不應以未閱讀本協議的內容等理由，主張本協議無效，或要求撤銷本協議。</li>
                        <li>1.3 本協議條款是處理雙方權利義務的契約，始終有效，法律另有強制性規定或雙方另有特別約定的除外。您承諾接受並遵守本協議的約定。如果您不同意本協議的約定，您應立即停止註冊程序或停止使用龍門比分網站或應用程序。</li>
                        <li>1.4 本公司有權根據需要不定期地制訂、修改本協議和/或各類規則，並在龍門比分旗下網站或應用程序公示。變更後的協議或規則一經公佈，立即生效。如您不同意相關變更，應當立即停止使用龍門比分服務。您繼續使用龍門比分服務的，即表明您接受修訂後的協議或各類規則。</li>
                    </ul>
                </li>
                <li>2 用戶管理</li>
                <ul>
                    <li>2.1 用戶須具有法定的相應權利能力和行為能力的自然人、法人或其他組織，能夠獨立承擔法律責任。您完成註冊程序或其他龍門比分同意的方式實際使用本公司服務時，即視為您確認自己具備主體資格，能夠獨立承擔法律責任。若您在18周歲以下，則您只能在父母或監護人的監護參與下才能使用龍門比分服務，因您不具備主體資格，而導致的一切後果，由您及您的監護人自行承擔。</li>
                    <li>2.2 用戶應自行誠信向龍門比分提供註冊資料，用戶同意其提供的註冊資料真實、準確、完整、合法有效，用戶註冊資料如有變動的，應及時更新其註冊資料。如果用戶提供的註冊資料不合法、不真實、不准確、不詳盡的，用戶需承擔因此引起的相應責任及後果，並且龍門比分保留終止用戶使用龍門比分旗下網站或應用程序各項服務的權利。</li>
                    <li>2.3 您註冊成功後，即成為龍門比分公司的用戶，將擁有龍門比分旗下網站網站與應用程序唯一編號的用戶名和密碼等賬戶信息，您可以根據本站規定改變您的密碼。</li>
                    <li>2.4 您設置的用戶名不得侵犯或涉嫌侵犯他人合法權益。否則，龍門比分有權終止向您提供服務，註銷您的賬戶。賬戶註銷後，相應的用戶名將開放給任意用戶註冊登記使用。</li>
                    <li>2.5 您應謹慎合理的保存、使用您的用戶名和密碼，應對通過您的用戶名和密碼實施的行為負責。除非有法律規定或司法裁定，且徵得龍門比分的同意，否則，用戶名和密碼不得以任何方式轉讓、贈與或繼承（與賬戶相關的財產權益除外）。</li>
                    <li>2.6 用戶不得將在龍門比分註冊獲得的賬戶借給他人使用，否則用戶應承擔由此產生的全部責任，並與實際使用人承擔連帶責任。</li>
                    <li>2.7 如果發現任何非法使用等可能危及您的賬戶安全的情形時，您應當立即以有效方式通知龍門比分，要求龍門比分暫停相關服務，並向公安機關報案。 龍門比分對您的請求採取行動需要合理時間，龍門比分對在採取行動前已經產生的後果（包括但不限於您的任何損失）不承擔任何責任。</li>
                    <li>2.8 用戶不得在龍門比分發表包含以下內容的言論</li>
                    <ul><li>2.8.1 反對憲法所確定的基本原則，煽動、抗拒、破壞憲法和法律、行政法規實施的；</li>
                        <li>2.8.2 煽動顛覆國家政權，推翻社會主義制度，煽動、分裂國家，破壞國家統一的；</li>
                        <li>2.8.3 損害國家榮譽和利益的；</li>
                        <li>2.8.4 煽動民族仇恨、民族歧視，破壞民族團結的；</li>
                        <li>2.8.5 任何包含對種族、性別、宗教、地域內容等歧視的；</li>
                        <li>2.8.6 捏造或者歪曲事實，散佈謠言，擾亂社會秩序的；</li>
                        <li>2.8.7 宣揚封建迷信、邪教、淫穢、色情、賭博、暴力、兇殺、恐怖、教唆犯罪的；</li>
                        <li>2.8.8 公然侮辱他人或者捏造事實誹謗他人的，或者進行其他惡意攻擊的；</li>
                        <li>2.8.9 其他違反憲法和法律法規的。</li></ul>
                    <li>2.9 用戶同意嚴格遵守以下義務：</li>
                    <ul><li>2.9.1 不得利用龍門比分從事洗錢、竊取商業秘密、竊取個人信息等違法犯罪活動；</li>
                        <li>2.9.2 不得乾擾龍門比分的正常運營，不得侵入網站及計算機信息系統；</li>
                        <li>2.9.3 不得利用在龍門比分註冊的賬戶進行牟利性經營活動；</li>S
                        <li>2.9.4 不得發布任何侵犯他人著作權、商標權及專利權等知識產權或其他合法權利的內容。</li></ul>
                </ul>
                <li>3 商品信息</li>
                <ul>
                    <li>3.1 龍門比分旗下網站或應用程序的商品價格、數量、是否有貨等商品信息隨時都有可能發生變動，不作特別通知。由於龍門比分的商品信息的數量龐大，雖然本站會盡最大努力保證您所瀏覽商品信息的準確性，但由於眾所周知的互聯網技術因素等客觀原因存在，顯示的信息可能會有一定的滯後性或差錯，對此情形您已知悉並理解。</li>
                </ul>
                <li>4 訂單</li>
                <ul>
                    <li>4.1 在本公司購物的用戶，請您仔細確認所購商品的名稱、價格、數量、型號、規格、尺寸等信息。因店鋪商家展示的商品和價格等信息僅僅是要約邀請，您下單時須完整填寫您希望購買的商品數量、價款及支付方式、收貨人、聯繫方式、收貨地址等內容。如果您提供的註冊資料不合法、不真實、不准確、不詳盡的，用戶需承擔因此引起的相應責任及後果，並且本公司保留終止用戶使用龍門比分各項服務的權利。</li>
                    <li>4.2 系統生成的訂單信息是計算機信息系統根據您填寫的內容自動生成的數據，僅是您向龍門比分，當龍門比分將訂單中的商品從倉庫實際向您發出時（以商品出庫為標誌），方視為您與龍門比分之間就實際發出的商品建立了合同關係。</li>
                    <li>4.3 您了解並同意，本公司旗下網頁或應用程序上的商品、價格、數量、是否有貨等商品信息隨時可能發生變動，不作特別通知。由於互聯網技術原因導致顯示信息可能會有一定的滯後性或差錯，對此在合同未成立前，您接受龍門比分在發現顯示錯誤正式向您發出通知並對商品信息進行調整後，訂單將按照正確的信息執行，或取消訂單。</li>
                    <li>4.4 您了解並同意，如您預訂商品，無法成單，您有權取消訂單；本公司無法保證您提交的訂單信息中希望購買的商品都會有貨。</li>
                    <li>4.5 龍門比分將會把商品送到您所指定的收貨地址。您了解本公司所提示的送貨時間供參考，實際送貨會與參考時間略有差異。龍門比分管理者和所有者或其關聯公司不對因您及收貨人原因導致無法送貨或延遲送貨承擔責任。若發生不可抗力或其他正當合理理由導致發貨延遲的，您將給予充分理解。</li>
                    <li>4.6 龍門比分保留在各國的法律允許的範圍內獨自決定拒絕服務、關閉用戶賬戶、清除或編輯內容或取消訂單的權利。</li>
                </ul>
                <li>5 知識產權</li>
                <ul>
                    <li>5.1 用戶一旦接受本協議，即表明該用戶主動將其在任何時間段在龍門比分旗下網站或應用程序發布的任何形式的信息內容（包括但不限於客戶評價、客戶諮詢、各類話題文章等信息內容）的財產性權利等任何可轉讓的權利，如著作權財產權（包括並不限於：複製權、發行權、出租權、展覽權、表演權、放映權、廣播權、信息網絡傳播權、攝製權、改編權、翻譯權、彙編權以及應當由著作權人享有的其他可轉讓權利），全部獨家且不可撤銷地轉讓給龍門比分所有，用戶同意龍門比分有權就任何主體侵權而單獨提起訴訟。</li>
                    <li>5.2 本協議已經構成《中華人民共和國著作權法》第二十五條（條文序號依照2011年版著作權法確定）及相關法律規定的著作財產權等權利轉讓書面協議，其效力及於用戶在龍門比分網站或應用程序上發布的任何受著作權法保護的作品內容，無論該等內容形成於本協議訂立前還是本協議訂立後。</li>
                    <li>5.3 用戶同意並已充分了解本協議的條款，承諾不將已發佈於龍門比分的信息，以任何形式發布或授權其它主體以任何方式使用 （包括但限於在各類網站、應用程序、媒體上使用）。</li>
                    <li>5.4 龍門比分是本網站與應用程序的製作者,擁有此網站和應用程序內容及資源的著作權等合法權利，受國家法律保護,有權不時地對本協議、網站、應用程序的內容進行修改，並在相應位置張貼，無須另行通知用戶。在法律允許的最大限度範圍內，龍門比分對本協議、網站、應用內容擁有解釋權。</li>
                    <li>5.5 除法律另有強制性規定外，未經龍門比分明確的特別書面許可,任何單位或個人不得以任何方式非法地全部或部分複制、轉載、引用、鏈接、抓取或以其他方式使用龍門比分旗下網站與應用程序的信息內容，否則，龍門比分有權追究其法律責任。</li>
                    <li>5.6 龍門比分旗下網站與應用程序所刊登的資料信息（諸如文字、圖表、標識、按鈕圖標、圖像、聲音文件片段、數字下載、數據編輯和軟件），均是龍門比分或其內容提供者的財產，受中國和國際版權法的保護。本站或應用程序所有內容的彙編是龍門比分的排他財產，受中國和國際版權法的保護。本站上所有軟件都是龍門比分或其關聯公司或其軟件供應商的財產，受中國和國際版權法的保護。</li>
                </ul>
                <li>6 隱私保護</li>
                <ul>
                    <li>6.1 龍門比分非常重視對用戶隱私權的保護，承諾不會在未獲得用戶許可的情況下擅自將用戶的個人資料信息洩露給任何第三方，但以下情況除外：</li>
                    <ul>
                        <li>6.1.1 政府部門、司法機關等依照法定程序要求龍門比分披露個人資料時，龍門比分將根據執法單位的要求或為公共安全的目的提供個人資料；</li>
                        <li>6.1.2 由於用戶將個人密碼告知他人或與他人共享註冊賬戶，由此導致的任何個人資料洩露；</li>
                        <li>6.1.3 任何由於計算機問題、黑客攻擊、計算機病毒侵入或發作、因政府管製而造成的暫時性關閉等影響網絡正常經營的不可抗力而造成的個人資料洩露、丟失、被盜用或被竄改等；</li>
                        <li>6.1.4 由於與龍門比分旗下網站或應用程序鏈接的其他網站所造成的個人資料洩露及由此而導致的任何法律爭議和後果。</li>
                    </ul>
                    <li>6.2 為了向用戶提供更優質的服務，用戶同意龍門比分可將您的個人信息提供給龍門比分的關聯公司。</li>
                    <li>6.3 用戶理解並認同，在龍門比分發生重組、解散、破產清算、併購等情況時，龍門比分可能會向第三方出售或轉讓。在該等交易中，作為龍門比分不可分割的一部分，您的用戶信息也可能將被轉讓給該第三方，以使該第三方可以繼續為您提供服務。</li>
                </ul>
                <li>7 協議的終止</li>
                <ul>
                    <li>7.1 您同意，龍門比分有權自行全權決定以任何理由不經事先通知的中止、終止向您提供部分或全部龍門比分網站服務，暫時凍結或註銷您的賬戶，且無須為此向您或任何第三方承擔任何責任。</li>
                    <li>7.2 出現以下情況時，龍門比分有權直接以註銷賬戶的方式終止本協議:</li>
                    <ul>
                        <li>7.2.1 您註冊信息中的主要內容不真實或不准確或不及時或不完整；</li>
                        <li>7.2.2 本協議（含規則）變更時，您明示並通知龍門比分不願接受新的服務協議的；</li>
                        <li>7.2.3 龍門比分終止向您提供服務後，您涉嫌再一次直接或間接或以他人名義註冊為龍門比分用戶的;</li>
                        <li>7.2.4 違反2.8及2.9條各項約定的。</li>
                    </ul>
                    <li>7.3 您有權向龍門比分要求註銷您的賬戶，經龍門比分審核同意的，龍門比分註銷您的賬戶，屆時，您與龍門比分基於本協議的合同關係即終止。您的賬戶被註銷後，龍門比分沒有義務為您保留或向您披露您賬戶中的任何信息，也沒有義務向您或第三方轉發任何您未曾閱讀或發送過的信息。</li>
                    <li>7.4 您同意，您與龍門比分的合同關係終止後，龍門比分仍享有下列權利：</li>
                    <ul>
                        <li>7.4.1 繼續保存您的註冊信息及您使用龍門比分旗下網站與應用程序服務期間的所有交易信息。</li>
                        <li>7.4.2 您在使用龍門比分各項產品服務期間存在違法行為或違反本協議和/或規則的行為的，龍門比分仍可依據本協議向您主張權利。</li>
                    </ul>
                    <li>7.5 本協議終止後，您在龍門比分賬戶內剩餘的優惠券同時作廢。</li>
                </ul>

                <li>8 免責事項</li>
                <ul><li>8.1 龍門比分在基於用戶提交信息提供的服務，如信息有誤，則用戶應對龍門比分予以免責。</li>
                    <li>8.2 關於商品的配送，龍門比分會將商品送到用戶在收件人地址處填寫的地址，完成此項時，即當配送服務提供商的記錄顯示用戶已經簽收，龍門比分視為配送工作已完成，用戶已經收到商品。</li>
                    <li>8.3 如用戶利用龍門比分的服務給其他用戶或第三方的利益造成損害，所有責任由該用戶自行承擔，龍門比分不承擔任何責任；對於用戶因各種條件無法接受龍門比分提供的服務時，給用戶或第三方帶來的損失，龍門比分不承擔任何責任。</li>
                    <li>8.4 本網站刊載的各類文章、廣告、您在本網站發表的觀點以及以鏈接形式推薦的其他網站內容，僅為提供更多信息以參考使用或者學習交流，並不代表本網站的立場和觀點。</li>
                    <li>8.5 由於法律規定的不可抗力，信息網絡正常的設備維護，信息網絡連接故障，電腦、通訊或其他系統的故障，黑客攻擊，電力故障，勞動爭議，生產力或生產資料不足，司法行政機關的命令或第三方的不作為及其他本公司無法控制的原因造成的龍門比分旗下網站或應用程序不能服務或延遲服務、丟失數據信息、記錄的，龍門比分不承擔責任，但將在法律、法規允許的範圍內協助處理相關事宜。</li>
                    <li>8.6 除本協議註明的服務條款外，其他一切因使用龍門比分旗下網站或應用程序而引致的任何意外、疏忽、誹謗、版權或知識產權侵犯及其所造成的損失（包括因下載而感染電腦病毒），龍門比分不承擔任何法律責任。</li></ul>

                <li>9 管轄法律及其他</li>
                <ul><li>9.1 本協議包含了您使用龍門比分旗下網站與應用程序需遵守的一般性規範，您在使用某個龍門比分產品時還需遵守適用於該產品的特殊性規範。一般性規範如與特殊性規範不一致或有衝突，則特殊性規範具有優先效力。</li>
                    <li>9.2 本協議的訂立、執行和解釋及爭議的解決均應適用在中華人民共和國香港地區適用的有效法律（但不包括其衝突法規則）。如發生本協議與適用的法律相抵觸時，則這些條款將完全按法律規定重新解釋，而其它有效條款繼續有效。</li>
                    <li>9.3 因本協議履行過程中，因您使用龍門比分服務產生爭議應由龍門比分與您溝通並協商處理。</li></ul>
            </ul>
        </article>
    );
};

export default UserAgreement;